import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams, useNavigate } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './NewsCategoriesPage.css';

const baseUrl = process.env.REACT_APP_NCLUDE_API;

function NewsCategoriesPage() {
    const { language, source } = useParams();
    const navigate = useNavigate();

    const [selectedLanguage, setSelectedLanguage] = useState('Hindi');
    const [categories, setCategories] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [showLoadMore, setShowLoadMore] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const booksPerPage = 10;

    // Fetch books on component mount
    useEffect(() => {
        if (language) {
            if (language.toLowerCase() == 'hindi') {
                setSelectedLanguage('hin');
            }
            else {
                setSelectedLanguage('eng');
            }
        }
        fetchNewsCategories();
    }, [language, source]);
    
    async function fetchNewsCategories() {
        setCurrentPage(1);
        try {
            setLoading(true);
            setError(null);
            
            let response = await axios.get(`${baseUrl}/v1/api/news/news-category?source=${source}`);
            const data = await response.data;
            setCategories(data);

            setShowLoadMore(false);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <div className='container'>
                <section className="header-wrap d-flex justify-content-start align-items-center">
                    <button onClick={() => { navigate(-1); }} className="btn btn-secondary">
                        Go Back
                    </button>
                    <h1 className="logo my-auto ms-4">
                        <span className="assistive-text">Shravan Audiobooks Library</span>
                    </h1>
                </section>
                {
                    categories != null && categories.length > 0 ?
                        (
                            <section className="audiobooks-container mt-5">
                                <div className="audio-book-feed justify-content-start align-items-center" id="secondary-content">
                                    <header>
                                        <h3 className="title text-start">
                                            Select a News Category Under {source}
                                        </h3>
                                    </header>
                                    <ul className='list-group audiobooks-list mt-3'>
                                        {
                                            categories.map((category, index) => (
                                                <li key={category}
                                                    className='list-group-item audiobook-item'>
                                                    <Link style={{ textDecoration: 'none', color: 'inherit' }}
                                                        to={`/category/${language}/news/${source}/${category}/articles`}
                                                    >
                                                        <div className="result-data d-flex justify-content-start align-items-baseline">
                                                            <p className='mb-0'>{index + 1}. {category}</p>
                                                        </div>
                                                    </Link>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </section>
                        ) :
                        <div className="empty-container mt-5">
                            {
                                categories && categories.length == 0 ?
                                (
                                    <p className='d-flex text-left'>No news categories found</p>
                                )
                                : ( <p></p> )              
                            }
                        
                        </div>
                }

            </div>
        </div>
    );
}

export default NewsCategoriesPage;
